import loadAppConfigLogic from "./loadAppConfigLogic";
import saveAppConfigLogic from "./saveAppConfigLogic";

export default [...loadAppConfigLogic, ...saveAppConfigLogic];
